import api from '../api';

export const deleteSale = async (id: number) => {
	const response = await api.delete(`venda?id=${id}`);
	return response.data;
};

export const deleteSaleByFilters = async (filters: any) => {
	const response = await api.post('venda/deletarPorFiltros', filters);
	return response.data;
};
